export default [
  {
    path: '/m',
    name: 'MobileHome',
    component: () => import('@/views/mobile/home/Index.vue'),
  },
  {
    path: '/m/home',
    name: 'MobileHome',
    component: () => import('@/views/mobile/home/Index.vue'),
    meta: {
      title: '首页',
    }
  },
  {
    path: '/m/list',
    name: 'MobileList',
    component: () => import('@/views/mobile/list/Index.vue'),
  },
  {
    path: '/m/news',
    name: 'MobileNews',
    component: () => import('@/views/mobile/news/Index.vue'),
  },
  {
    path: '/m/404',
    name: 'Mobile404',
    component: () => import('@/views/mobile/404.vue'),
  },
]